import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../_services/session/session.service';

export const supportWorkspaceGuard: CanActivateFn = () =>
  inject(SessionService).getActiveMode() === 'professional' ||
  inject(Router).parseUrl('/patient/home');
